import React, {useEffect} from "react";
import "./Component41.css";
import Carousel from "react-bootstrap/Carousel";
import limo1 from "../img/limo stretch.jpg";
import benz from "../img/benz.jpg";
import mkt from "../img/mkt.png";
import escalade from "../img/Escalade limo.jpg";
import cadi from "../img/cadillac.webp";
import chevrolet from "../img/chevrolet.jpg";
import ford from "../img/ford.jpg";
import partyv from "../img/partyyy.jpg";
import sprinter from "../img/sprinter van.png";
import delivery from "../img/delivery van.webp";
import vip from "../img/vip.png";
import dryv from "../img/dry van 2.webp";
import AOS from "aos";
import "aos/dist/aos.css";



const Component41 = () => {
  useEffect(() => {
    AOS.init({ duration: 2000 });
  }, []);
  return (
    <div className="div41" data-aos="zoom-in">
      <h1 className="h22">Our FLeet</h1>
      <Carousel className="carol">
        <Carousel.Item>
          <img className="img7" src={benz} alt="First slide" />
          <Carousel.Caption>
            <h3 className="carName">Mercedes Benz S550</h3>
          </Carousel.Caption>
        </Carousel.Item>
        <Carousel.Item>
          <img className="img7" src={limo1} alt="Second slide" />

          <Carousel.Caption>
            <h3 className="carName">Stretch Limo</h3>
          </Carousel.Caption>
        </Carousel.Item>
        <Carousel.Item>
          <img className="img7" src={mkt} alt="Third slide" />

          <Carousel.Caption>
            <h3 className="carName">Mkt</h3>
          </Carousel.Caption>
        </Carousel.Item>
        <Carousel.Item>
          <img className="img7" src={escalade} alt="Third slide" />

          <Carousel.Caption>
            <h3 className="carName">Escalade</h3>
          </Carousel.Caption>
        </Carousel.Item>
        <Carousel.Item>
          <img className="img7" src={cadi} alt="Third slide" />

          <Carousel.Caption>
            <h3 className="carName">Cadillac</h3>
          </Carousel.Caption>
        </Carousel.Item>
        <Carousel.Item>
          <img className="img7" src={chevrolet} alt="Third slide" />

          <Carousel.Caption>
            <h3 className="carName">Chevrolet</h3>
          </Carousel.Caption>
        </Carousel.Item>
        <Carousel.Item>
          <img className="img7" src={ford} alt="Third slide" />

          <Carousel.Caption>
            <h3 className="carName">Ford</h3>
          </Carousel.Caption>
        </Carousel.Item>
        <Carousel.Item>
          <img className="img7" src={partyv} alt="Third slide" />

          <Carousel.Caption>
            <h3 className="carName">Party Van</h3>
          </Carousel.Caption>
        </Carousel.Item>
        <Carousel.Item>
          <img className="img7" src={sprinter} alt="Third slide" />

          <Carousel.Caption>
            <h3 className="carName">Sprinter Van</h3>
          </Carousel.Caption>
        </Carousel.Item>
        <Carousel.Item>
          <img className="img7" src={delivery} alt="Third slide" />

          <Carousel.Caption>
            <h3 className="carName">Delivery Van</h3>
          </Carousel.Caption>
        </Carousel.Item>
        <Carousel.Item>
          <img className="img7" src={vip} alt="Third slide" />

          <Carousel.Caption>
            <h3 className="carName">Shuttle Bus</h3>
          </Carousel.Caption>
        </Carousel.Item>
        <Carousel.Item>
          <img className="img7" src={dryv} alt="Third slide" />

          <Carousel.Caption>
            <h3 className="carName">Dry Van</h3>
          </Carousel.Caption>
        </Carousel.Item>
      </Carousel>
    </div>
  );
};

export default Component41;
